import React from "react";
import { Link } from "../components/L";
import { ClipboardList, Sparkles, Smile, ArrowRight, ShieldCheck, UserCheck, CalendarClock, Languages } from "lucide-react";
import Seo from "../components/Seo";
import CTABand from "../components/CTABand";
import { useLang } from "../context/LanguageContext";

const iconMap = { ClipboardList, Sparkles, Smile, ShieldCheck, UserCheck, CalendarClock, Languages };

const HowItWorks = () => {
  const { lang, t } = useLang();
  const h = t.how;
  const seo = lang === "de"
    ? { title: "So funktioniert MyCleaner | MyCleaner.ch", description: "In 3 Schritten zur persönlichen Putzfrau: Anfrage senden, geprüfte Putzfrau erhalten, entspannt geniessen. Fixpreis 43.90 CHF/Std., ohne Kreditkarte.", keywords: "Putzfrau buchen, Putzfrau Vermittlung Ablauf, Haushaltshilfe finden Schweiz" }
    : { title: "How MyCleaner works | MyCleaner.ch", description: "Your personal cleaner in 3 simple steps: send a request, get a vetted cleaner, sit back and relax. Flat rate CHF 43.90/hr, no credit card.", keywords: "book a cleaner, cleaner placement process, home help Switzerland" };

  return (
    <div>
      <Seo pageKey="howitworks" title={seo.title} description={seo.description} keywords={seo.keywords} />

      <section className="pt-[116px] pb-16 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-[820px] mx-auto px-5 md:px-6 text-center">
          <p className="text-teal-600 font-semibold text-sm tracking-wide uppercase mb-3">{h.eyebrow}</p>
          <h1 className="font-head font-extrabold text-4xl md:text-5xl leading-tight text-slate-900 mb-5">{h.title}</h1>
          <p className="text-lg text-slate-600">{h.subtitle}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1000px] mx-auto px-5 md:px-6 space-y-10">
          {t.steps.map((st, i) => {
            const Icon = iconMap[st.icon];
            return (
              <div key={st.num} className={`flex flex-col md:flex-row items-center gap-8 ${i % 2 === 1 ? "md:flex-row-reverse" : ""}`}>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="w-10 h-10 rounded-full bg-teal-700 text-white font-head font-bold flex items-center justify-center">{st.num}</span>
                    <span className="text-teal-600 font-semibold uppercase text-sm tracking-wide">{h.step} {st.num}</span>
                  </div>
                  <h2 className="font-head font-extrabold text-2xl md:text-3xl text-slate-900 mb-3">{st.title}</h2>
                  <p className="text-slate-600 text-lg leading-relaxed">{st.desc}</p>
                </div>
                <div className="flex-1 w-full">
                  <div className="rounded-2xl bg-teal-50 aspect-[16/10] flex items-center justify-center">
                    <Icon className="w-20 h-20 text-teal-600" strokeWidth={1.2} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-16 bg-amber-50/50">
        <div className="max-w-[1200px] mx-auto px-5 md:px-6">
          <h2 className="font-head font-extrabold text-3xl text-slate-900 text-center mb-12">{h.safeTitle}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {t.trustPoints.map((tp) => {
              const Icon = iconMap[tp.icon];
              return (
                <div key={tp.title} className="bg-white rounded-2xl border border-slate-100 p-6">
                  <Icon className="w-8 h-8 text-teal-700 mb-4" />
                  <h3 className="font-head font-bold text-slate-900 mb-2">{tp.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{tp.desc}</p>
                </div>
              );
            })}
          </div>
          <div className="text-center mt-12">
            <Link to="/buchen" className="inline-flex items-center gap-2 bg-teal-700 text-white font-head font-bold text-lg px-8 py-4 rounded-xl hover:bg-teal-800 transition-colors">{h.book} <ArrowRight className="w-5 h-5" /></Link>
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default HowItWorks;
